import type { Load } from 'api';
import { formatDateTime } from 'date';
import { translate } from 'i18n';
import type { DataGridColumn } from 'ui';

import { RISK_SCORE_OPTIONS, RiskScoreChip } from '../../../risk';
import { LoadStatusChip } from '../../components/LoadStatusChip/LoadStatusChip';
import { LOADS_STATUS_OPTIONS } from './constants';

export const columns: DataGridColumn<Load>[] = [
  {
    columnSize: 'small',
    field: 'deal_id',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.deal', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'small',
    field: 'id',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.load', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'material',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.material', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'medium',
    field: 'status',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.status', { namespace: 'features' }),
    renderCell: (params) => {
      return <LoadStatusChip status={params.value} />;
    },
    sortable: true,
    type: 'singleSelect',
    valueOptions: LOADS_STATUS_OPTIONS,
  },
  {
    columnSize: 'medium',
    field: 'risk_score',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.risk', { namespace: 'features' }),
    renderCell: (params) => {
      return <RiskScoreChip riskScore={params.value} />;
    },
    sortable: true,
    type: 'singleSelect',
    valueOptions: RISK_SCORE_OPTIONS,
  },
  {
    columnSize: 'large',
    field: 'producer',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.producer', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'end_processor',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.endProcessor', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'loading_site',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.loadingSite', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'large',
    field: 'destination',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.destination', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'small',
    field: 'inspection_id',
    filterable: true,
    headerName: translate('backlog.loadsList.columns.hasInspection', { namespace: 'features' }),
    sortable: false,
    type: 'singleSelect',
    valueFormatter: (value) =>
      value
        ? translate('backlog.loadsList.values.yes', { namespace: 'features' })
        : translate('backlog.loadsList.values.no', { namespace: 'features' }),
    valueOptions: [
      {
        label: translate('backlog.loadsList.values.yes', { namespace: 'features' }),
        value: true,
      },
      {
        label: translate('backlog.loadsList.values.no', { namespace: 'features' }),
        value: false,
      },
    ],
  },
  {
    columnSize: 'large',
    field: 'estimated_collection_time',
    filterable: false,
    headerName: translate('backlog.loadsList.columns.collectionTime', { namespace: 'features' }),
    renderCell: (params) => {
      return params.value
        ? formatDateTime(params.value)
        : translate('backlog.loadsList.values.notAvailable', { namespace: 'features' });
    },
    sortable: false,
  },
];
